export const counter = () => {
    const counterElement = document.querySelectorAll('[counter]');
          
    if (!counterElement) return;

    const interval = setInterval(() => {
        const pivotElement = counterElement[0],
              pivotValue = parseInt(pivotElement.innerHTML.replace(/,/g, '')),
              suma = pivotValue + Math.floor(Math.random() * 7);
        if (suma > 100000) clearInterval(interval);
        counterElement.forEach((element) => {
            element.innerHTML = suma.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        })
    }, 2000)
}